<app-small-spinner [show]="showSpinner"></app-small-spinner>
<div *ngIf="!showSpinner" class="myAccount-content">
    <h3>Pending Orders</h3>
    <div class="recent-orders-table table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Order Ref</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let order of orders">
                    <td>#{{order.orderRefId}}</td>
                    <td>{{order.createdAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</td>
                    <td>${{order.course.price}}</td>
                    <td>Pending</td>
                    <td><a (click)="routeToCourseDetail(order.course.id)" class="view-button">Course Detail</a></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>